module.exports = __webpack_public_path__ + "static/wpack/extracted/light-bulb4ef453bd24c060999dce1ca63f416873.svg";